module.exports = __webpack_public_path__ + "img/car5.f2dcf157.png";